import React from 'react';
import { LayoutGrid, List as ListIcon, Filter, ArrowDownUp, MoreHorizontal, ChevronRight } from 'lucide-react';
interface ToolbarProps {
  view: 'board' | 'list';
  setView: (view: 'board' | 'list') => void;
  issueCount: number;
  title: string;
}
export function Toolbar({
  view,
  setView,
  issueCount,
  title
}: ToolbarProps) {
  return <div className="h-12 border-b border-[#eef0f2] flex items-center justify-between px-6 bg-white flex-shrink-0 text-[13px]" data-id="element-189">
      <div className="flex items-center text-slate-600" data-id="element-190">
        <div className="w-4 h-4 rounded bg-orange-100 text-orange-600 flex items-center justify-center text-[10px] font-bold mr-2 shadow-sm" data-id="element-191">
          E
        </div>
        <span className="font-medium hover:text-slate-900 cursor-pointer transition-colors" data-id="element-192">
          Engineering
        </span>
        <ChevronRight className="w-3.5 h-3.5 mx-1.5 text-slate-300" data-id="element-193" />
        <span className="font-medium text-slate-900" data-id="element-194">{title}</span>
        <span className="ml-3 text-slate-400" data-id="element-195">{issueCount}</span>
      </div>

      <div className="flex items-center space-x-1.5" data-id="element-196">
        <button className="flex items-center px-2 py-1 text-slate-500 hover:text-slate-900 hover:bg-slate-100 rounded transition-colors font-medium" data-id="element-197">
          <Filter className="w-3.5 h-3.5 mr-1.5" data-id="element-198" />
          Filter
        </button>
        <button className="flex items-center px-2 py-1 text-slate-500 hover:text-slate-900 hover:bg-slate-100 rounded transition-colors font-medium" data-id="element-199">
          <ArrowDownUp className="w-3.5 h-3.5 mr-1.5" data-id="element-200" />
          Sort
        </button>
        <button className="flex items-center px-2 py-1 text-slate-500 hover:text-slate-900 hover:bg-slate-100 rounded transition-colors font-medium" data-id="element-201">
          View
        </button>

        <div className="w-px h-3.5 bg-slate-200 mx-1" data-id="element-202"></div>

        {/* View Switcher */}
        <div className="flex items-center bg-slate-100/50 p-0.5 rounded border border-slate-200/60" data-id="element-203">
          <button onClick={() => setView('list')} className={`p-1 rounded-[3px] flex items-center justify-center transition-all ${view === 'list' ? 'bg-white shadow-sm text-slate-900 border border-slate-200/50' : 'text-slate-400 hover:text-slate-600 border border-transparent'}`} title="List View" data-id="element-204">
            <ListIcon className="w-3.5 h-3.5" data-id="element-205" />
          </button>
          <button onClick={() => setView('board')} className={`p-1 rounded-[3px] flex items-center justify-center transition-all ${view === 'board' ? 'bg-white shadow-sm text-slate-900 border border-slate-200/50' : 'text-slate-400 hover:text-slate-600 border border-transparent'}`} title="Board View" data-id="element-206">
            <LayoutGrid className="w-3.5 h-3.5" data-id="element-207" />
          </button>
        </div>

        <button className="flex items-center p-1 text-slate-400 hover:text-slate-900 hover:bg-slate-100 rounded transition-colors ml-1" data-id="element-208">
          <MoreHorizontal className="w-4 h-4" data-id="element-209" />
        </button>
      </div>
    </div>;
}